import { canUseDOM } from './canUseDOM';
/**
 * @hidden
 */
export function isRtl(element) {
    return Boolean(canUseDOM && element && getComputedStyle(element).direction === 'rtl');
}
/**
 * @hidden
 */
export function getDir(element, initialDir) {
    if (!initialDir && canUseDOM && element) {
        // Note: getComputedStyle forces reflow
        var rtlCandidate = window.getComputedStyle(element).direction;
        if (rtlCandidate) {
            // rerender is needed as DOM is read after first render
            return rtlCandidate;
        }
    }
    return initialDir;
}
